import CloseIcon from '@mui/icons-material/Close';
import { Box, useMediaQuery } from '@mui/material';
import type { ToastNotificationTypes } from 'components/ToastMessage/ToastMessage.contants';
import theme from 'providers/theme/theme';
import React, { type FC } from 'react';

import type { CloseButtonProps } from 'react-toastify';
import { ToastifyMessageCloseButtonStyle } from './ToastifyMessage.styles';

interface IToastifyMessageProps {
  type?: keyof typeof ToastNotificationTypes;
  message?: string | React.ReactNode;
  title?: string;
}

const ToastifyMessage: FC<IToastifyMessageProps> = ({ type: _type, message, title }) => (
  <>
    <Box className="toastify_vertical-line" />
    <Box className="toastify__content">
      {title && (
        <>
          <strong>{title}</strong>
          <br />
          <br />
        </>
      )}

      {message}
    </Box>
  </>
);

export const ToastifyMessageCloseButton: FC<Partial<CloseButtonProps>> = ({ closeToast }) => {
  const isMobileLayout = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box onClick={closeToast} sx={ToastifyMessageCloseButtonStyle}>
      <CloseIcon fontSize={isMobileLayout ? 'small' : 'medium'} />
    </Box>
  );
};

export default ToastifyMessage;
